import { Card, Tabs } from '@seiue/ui'
import { Breadcrumb } from 'antd'
import { $t } from 'packages/locale'
import { PermEnum } from 'packages/sdks-next/growp'
import { FC, useContext, useState } from 'react'
import styled, { css } from 'styled-components'

import { GatewayContext } from '../context'

import { HotNewsList } from './HotNewsList'

/**
 * 资讯
 *
 * @returns - FC
 */
export const MyNews: FC = () => {
  const { setModule, perms } = useContext(GatewayContext)

  const hasHotNewsPermission =
    perms?.schoolBackgroundPerms?.includes(PermEnum.All) ||
    perms?.schoolBackgroundPerms?.includes(PermEnum.Information)

  const [selectedKey, setActiveKey] = useState<string>('inbox')

  return (
    <Box>
      <Breadcrumb>
        <BreadcrumbItem
          $clickable={true}
          onClick={() => {
            setModule('index')
          }}
        >
          {$t('首页')}
        </BreadcrumbItem>
        <BreadcrumbItem $selected={true}>{$t('资讯列表')}</BreadcrumbItem>
      </Breadcrumb>
      <Card
        contentStyle={{ padding: hasHotNewsPermission ? 0 : '0 20px' }}
        style={{ minWidth: 600, height: '100%' }}
      >
        {hasHotNewsPermission ? (
          <StyledTabs
            tabBarStyle={{ marginBottom: 0 }}
            items={[
              {
                key: 'inbox',
                label: (
                  <BoxTabTitle $selected={selectedKey === 'inbox'}>
                    {$t('收件箱')}
                  </BoxTabTitle>
                ),
                children: (
                  <HotNewsList
                    type="inbox"
                    hasHotNewsPermission={true}
                    selectedKey={selectedKey}
                  />
                ),
              },
              {
                key: 'outbox',
                label: (
                  <BoxTabTitle $selected={selectedKey === 'outbox'}>
                    {$t('发件箱')}
                  </BoxTabTitle>
                ),
                children: (
                  <HotNewsList
                    type="outbox"
                    hasHotNewsPermission={true}
                    selectedKey={selectedKey}
                  />
                ),
              },
            ]}
            onChange={setActiveKey}
          />
        ) : (
          <HotNewsList
            type="inbox"
            hasHotNewsPermission={false}
          />
        )}
      </Card>
    </Box>
  )
}

const Box = styled.div`
  height: calc(100vh - 64px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  overflow: auto;
  min-width: 1000px;
  max-width: 1640px;
  margin: 0 auto;
`

const BoxTabTitle = styled.div<{ $selected?: boolean }>`
  ${({ $selected, theme }) =>
    $selected &&
    css`
      color: ${theme.brand.text0};
    `}
`

const BreadcrumbItem = styled(Breadcrumb.Item)<{
  $clickable?: boolean
  $selected?: boolean
}>`
  cursor: pointer;
  ${({ $clickable, theme }) =>
    $clickable &&
    css`
      &:hover {
        color: ${theme.text._1};
      }
    `}
  ${({ $selected, theme }) =>
    $selected &&
    css`
      color: ${theme.text._1};
    `}
`

const StyledTabs = styled(Tabs)`
  &&& {
    .ant-tabs-tab {
      margin-left: 20px;
      padding: 0;
      min-width: fit-content;
    }
    .ant-tabs-content {
      padding: 0 20px 20px;
    }
  }
`
